import React from "react";
import Nav from 'react-bootstrap/Nav';
import {useRouter} from 'util/router'

function PartnerWidgetNav({show, selectedIndex, url}) {

    const router = useRouter()

    if (!show) {
        return null
    }

    function stripTrailingSlash(str) {
        if(str.substr(-1) === '/') {
            return str.substr(0, str.length - 1);
        }
        return str;
    }

    url = stripTrailingSlash(url)

    // let { path, url } = useRouteMatch();
    return (
        <>
        <Nav id="checkoutNav" className="d-flex flex-row mx-1 mt-3">
            <Nav.Item>
                <Nav.Link
                onClick={() => router.push(url)}
                eventKey={0}
                className={selectedIndex == 0 ? "selected primaryColor pl-0" : "primaryColor pl-0"}
                >
                    SCHEDULE
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link 
                onClick={() => router.push(url+"/pricing")}
                eventKey={selectedIndex < 1 ? "disabled" : 1}
                className={selectedIndex == 1 ? "selected primaryColor pl-0" : "primaryColor pl-0"}
                >
                    PRICING
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link 
                onClick={() => router.push(url+"/on-demand")}
                eventKey={selectedIndex < 2 ? "disabled" : 2}
                className={selectedIndex == 2 ? "selected primaryColor pl-0" : "primaryColor pl-0"}
                >
                    ON-DEMAND
                </Nav.Link>
            </Nav.Item>
            {/* <Nav.Item>
                <Nav.Link 
                onClick={() => router.push(url+"/buy")}
                eventKey={selectedIndex < 2 ? "disabled" : 2}
                className={selectedIndex == 2 ? "selected primaryColor" : "primaryColor"}
                >
                    STORE
                </Nav.Link>
            </Nav.Item> */}
        </Nav>
    </>
    )
}

export default PartnerWidgetNav
